<template lang="pug">
CardMinimal.font-sans
  .flex-1.flex.items-center.justify-between.p-4.border-b.border-gray-200
    div
      p.text-sm.leading-5.text-gray-700
        | {{`Showing reports for `}}
        span.font-semibold.text-gray-800 {{ start }}
        |  {{` - `}}
        span.font-semibold.text-gray-800 {{ end }}

    div
      nav.relative.z-0.inline-flex.shadow-sm
        a.relative.inline-flex.items-center.px-2.py-2.rounded-l-md.border.border-gray-300.bg-white.text-sm.leading-5.font-medium.text-gray-500.transition.ease-in-out.duration-150(href='#' class='hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500' aria-label='Previous' @click="changeMonth(-1)")
          svg.h-5.w-5(viewbox='0 0 20 20' fill='currentColor')
            path(fill-rule='evenodd' d='M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z' clip-rule='evenodd')
        span.-ml-px.relative.inline-flex.items-center.px-4.py-2.border.border-gray-300.bg-white.text-sm.leading-5.font-medium.text-gray-700
          | {{start}} - {{ end }}
        a.-ml-px.relative.inline-flex.items-center.px-2.py-2.rounded-r-md.border.border-gray-300.bg-white.text-sm.leading-5.font-medium.text-gray-500.transition.ease-in-out.duration-150(href='#' class='hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500' aria-label='Next' v-if="canStepForward", @click="changeMonth(1)")
          svg.h-5.w-5(viewbox='0 0 20 20' fill='currentColor')
            path(fill-rule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clip-rule='evenodd')

  template(v-if="fetchingRevenue")
    div.loading
      i.mdi.mdi-loading.mdi-spin
  template(v-else)
    template(v-if="!data")
      div.no-reports
        p {{ $t('commerce.sorry_no_report') }}
    template(v-else)
      .my-3
        template(v-for="(v, key, i) in data")
          .font-semibold.font-sans.p-4
            | {{ $t('commerce.revenue') }} ({{ key }})
          .container.flex.font-sans(class="flex-col lg:flex-row")
            .flex-1.p-4
              .m-b-2.font-semibold.text-gray-600 {{ $t('payout.net_sales') }}
              .font-semibold.text-2xl.text-green-400 {{ data[key].total_revenue_after_fees | amount(key) }}
            .flex-1.p-4.border-l.border-gray-200
              .m-b-2.font-semibold.text-gray-600 {{ $t('payout.deducted_fees') }}
              .font-semibold.text-2xl.text-gray-800 {{ data[key].total_fees | amount(key) }}
              .flex.flex-row.m-t-2
                  .flex-1.text-gray-500 {{ $t('payout.transaction_costs') }}
            .flex-1.p-4.border-l.border-gray-200
              .m-b-2.font-semibold.text-gray-600 {{ $t('payout.gross_sales') }}
              .font-semibold.text-2xl {{ data[key].total_revenue | amount(key) }}
              .flex.flex-row.m-t-2.font-medium.text-gray-600
                .flex-1
                  | {{ data[key].total_transactions }} {{ $t('payout.transactions') }}
</template>

<script>

import moment from 'moment';

export default {
  data() {
    return {
      canStepForward: false,
      data: null,
      fetchingRevenue: true,
      start: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    };
  },
  mounted() {
    this.fetchRevenue();
  },
  methods: {
    changeMonth(direction) {
      if (direction < 0) {
        this.start = moment(this.start).subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
        this.end = moment(this.end).subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
      } else {
        this.start = moment(this.start).add(1, 'month').startOf('month').format('YYYY-MM-DD');
        this.end = moment(this.end).add(1, 'month').endOf('month').format('YYYY-MM-DD');
      }

      if (this.start === moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')) {
        this.canStepForward = false;
      } else {
        this.canStepForward = true;
      }

      this.fetchRevenue();
    },
    async fetchRevenue() {
      this.fetchingRevenue = true;
      const revenue = await ovpFetch(`/pay/transactions/revenue?start=${this.start}&end=${this.end}`).catch(() => false);
      this.fetchingRevenue = false;
      if (!revenue || Object.keys(revenue.data).length <= 0) {
        this.data = null;
        return;
      }
      this.data = revenue.data;
    },
  },
  filters: {
    formatNumbers(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
};
</script>

<style lang="sass" scoped>
.no-reports, .loading
  align-items: center
  display: flex
  justify-content: center
  padding: 5rem 0
  width: 100%

  i
    color: #c1c1c1
    font-size: 3rem

.revenue-report
  h1, h2
    font-weight: 100
  h1
    line-height: 3rem
  h2
    line-height: 2.5rem
    i
      &:hover
        cursor: pointer
  label
    color: #757575
  p
    font-size: 1.1rem
    line-height: 1.5rem
</style>
